


















































import mixins from 'vue-typed-mixins'
import Openable from '@/global/viewmodels/openable'
import SendMailModel from '../model/SendMailModel'
import mobileTypeMixin from '@/global/mobile/mobileTypeMixin'

export default mixins(mobileTypeMixin).extend({
    props: { dialog: Openable, mail: SendMailModel },
    data() {
        return {
            formValid: false, // Passera 'true' si le formulaire est rempli correctement (voir conditions).
            hover: false,
            timeoutHover: null as NodeJS.Timeout | null
        }
    },
    methods: {
        envoyerMail() {
            this.$emit('send-mail', this.mail)
            this.closeDialog()
        },
        addDropFile(e: any) {
            this.hover = false
            this.mail.files = Array.from(e.dataTransfer.files)
        },
        closeDialog() {
            this.dialog.close()
        },
    },
    mounted() {
        document.addEventListener('dragover', () => {
            this.hover = true

            if (this.timeoutHover) {
                clearTimeout(this.timeoutHover)
                this.timeoutHover = null
            }
        })
        document.addEventListener('dragleave', () => {
            this.timeoutHover = setTimeout(() => {
                this.hover = false
            }, 500)
        })
    },
})
